import { EntryRef } from "../../schema/sys";
import { ContributorEntry } from "../../schema/semantics";
import { createArticleContributorProps } from "./article-contributors.props";
import { ContributorProps } from "design-system/components/primitives/contributors/contributors";

export type { ContributorProps };

export const createContributorProps = () => {
  const contribs: ContributorProps = {
    editors: [],
    photographers: [],
    photoeditors: [],
    illustrators: [],
    interviewees: [],
    interviewers: [],
    translators: [],
    hosts: [],
    videographers: [],
    narrators: [],
    additionalCredits: [],
  };
  return contribs;
};

export const ContentfulContributorsProps = (
  entries: Array<EntryRef<ContributorEntry>>,
) => {
  const contributors: ContributorProps = createContributorProps();

  entries.forEach((entry) => {
    const entryProps = createArticleContributorProps(entry);
    if (!entryProps?.type) return;
    switch (entryProps.type) {
      case "Host":
        contributors.hosts.push(entryProps);
        break;
      case "Interviewer":
        contributors.interviewers.push(entryProps);
        break;
      case "Interviewee":
        contributors.interviewees.push(entryProps);
        break;
      case "Narrator":
        contributors.narrators.push(entryProps);
        break;
      case "Translator":
        contributors.translators.push(entryProps);
        break;
      case "Editor":
        contributors.editors.push(entryProps);
        break;
      case "Videographer":
        contributors.videographers.push(entryProps);
        break;
      case "Photographer":
        contributors.photographers.push(entryProps);
        break;
      case "Photo Editor":
        contributors.photoeditors.push(entryProps);
        break;
      case "Illustrator":
        contributors.illustrators.push(entryProps);
        break;
      default: // Preserved to prevent an FE break should the options change in the schema
        contributors.additionalCredits.push(entryProps);
        break;
    }
  });

  return contributors;
};
